import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { Lodging } from "@b2bportal/lodging-api";
import { Dialog, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./AboutHotelSection.module.scss";
import { useAboutHotelSection } from "./hooks";

export interface AboutHotelSectionComponentProps
  extends PlatformComponentProps {
  hotel: Lodging;
}

const COMPONENT_KEY = CoreHotelsComponent.AboutHotelSection;
export const AboutHotelSection = (props: AboutHotelSectionComponentProps) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className } = props;

  const { text } = useAboutHotelSection(props);

  return (
    <div className={clsx(block, className)}>
      <h2 className={cn("title")}>{text.title}</h2>
      <div className={cn("content")}>{text.content}</div>

      <Dialog>
        <DialogTrigger className={cn("read-more")}>
          {text.readMore}
        </DialogTrigger>
        <DialogContent title={text.title}>
          <p className={cn("dialog-content")}>{text.content}</p>
        </DialogContent>
      </Dialog>
    </div>
  );
};
